import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setCurrentShipTo from "@insite/client-framework/Store/Context/Handlers/SetCurrentShipTo";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import updateShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";
import {
    getCurrentShipTosDataView,
    getCurrentShipToState,
} from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay from "@insite/content-library/Components/AddressInfoDisplay";
// import CustomerAddressForm from "@insite/content-library/Components/CustomerAddressForm";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Edit3 from "@insite/mobius/Icons/Edit3";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import EditIcon from "@MasterBluePrint/Icons/EditIcon";
import CustomerAddressForm from "@MasterBluePrint/Overrides/Components/CustomerAddressForm"
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state).value,
    currentShipTosDataView: getCurrentShipTosDataView(state),
    currentBillTo: getCurrentBillToState(state).value,
    // shipTo: ShipToModel,
    countries: getCurrentCountries(state),
    shipToAddressFields: getAddressFieldsDataView(state).value?.shipToAddressFields,
});

const mapDispatchToProps = {
    updateShipTo,
    setCurrentShipTo,
    loadCurrentShipTos,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CurrentShippingAddressStyles {
    gridContainer?: GridContainerProps;
    headingGridItem?: GridItemProps;
    headingText?: TypographyProps;
    editLinkGridItem?: GridItemProps;
    editLink?: LinkPresentationProps;
    addressFormModal?: ModalPresentationProps;
    addressInfoDisplayGridItem?: GridItemProps;
    useBillingAddressButtonGridItem?: GridItemProps;
    useBillingAddress?: UseBillingAddressStyles;    
    addressFormModalCustom?: InjectableCss;
    closeContainer?: InjectableCss;
    currentAddressAction?: InjectableCss;
    deleteLink?: LinkPresentationProps;
}

interface UseBillingAddressStyles {
    button?: ButtonPresentationProps;
}

export const currentShippingAddressStyles: CurrentShippingAddressStyles = {
    editLink: {
        css: css`
            padding-left: 1.25rem;
            margin-left: 0.9375rem;
            border-left: 1px solid ${themeColors.colorBorderBrands};
            

            svg {
                width: 1.25rem;
                height: 1.25rem;
            }
        `,
    },
    deleteLink: {
        css: css`
            svg {
                width: 1.25rem;
                height: 1.25rem;
                color: ${themeColors.colorBattleshipGray};
            }
        `,
    },
    currentAddressAction: {
        css:css`
            display: flex;
            width: 100%;
            align-items: center;
            margin-top: auto;
            border-top: 1px solid ${themeColors.colorBorderBrands};
            padding-top: 0.625rem;
            justify-content: space-between;
        `,
    },
    closeContainer: {
        css: css`
            position: absolute;
            left: 1.8rem;
            top: -5rem;
            z-index: 9;
            cursor: pointer;
            .close-label {
                color: ${themeColors.colorBrandsSeeMore};
                font-family: Roboto;
                font-size: 0.875rem;
                letter-spacing: 0;
                line-height: 1;
                display: inline-block;
                margin-right: 0.525rem;
                vertical-align: middle;
            }
            .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1rem;
                height: 1rem;
                svg {
                    height: 1rem;
                    width: 1rem;
                    color: ${themeColors.colorBrandsSeeMore};
                }
            }
            @media screen and (max-width: 990px) {
                right: 1.25rem;
            }
        `,
    },
    gridContainer: { 
        gap: 2,
        css:css`
            border: 1px solid ${themeColors.colorPaleAqua};
            border-radius: 0.125rem;
            margin: 0.625rem 0;

            > div {
                background-color: ${themeColors.colorAliceBlue};
                padding: 2.125rem 1.0625rem 1.0625rem 2.0625rem;
                min-height: 25.625rem; 
                border: 1px solid ${themeColors.colorPaleAqua};
                flex-flow: column;
                border-radius: 0.125rem;
            }
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null, 
                        css`
                            margin: 0;
                        `,
                        null,
                    ],
                    "max",
                )
            };
        `,

     },
    headingGridItem: { width: 12 },
    headingText: { 
        variant: "h5", 
        css:css`
            color: ${themeColors.colorPrimary};
            font-family: Roboto;
            font-size: 1.125rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.4375rem;

            .defaultText {
                color: ${themeColors.colorBrandsSeeMore};
                font-family: Lato;
                font-size: 0.9375rem;
                font-style: italic;
                font-weight: ${themeFontWeights.fontWeightForBold};
                letter-spacing: 0.17px;
                line-height: 1.125rem;
            }
        `,
    },
    editLinkGridItem: { 
        width: 2,
        css:css`
        justify-content: flex-end;
    }
        `,
    },
    addressFormModal: { sizeVariant: "medium" },
    addressFormModalCustom: {
        css:css`
            div[class^='ModalContent'], 
            div[class*=' ModalContent']{
                position: relative;
                padding-bottom: 11.1875rem !important;
                height: calc(100vh - 13.1875rem);

                @media screen and (max-width: 767px) {
                    padding-bottom: 10.1875rem !important;  
                    height: calc(100vh - 13.1875rem);
                }
                @media screen and (max-width: 540px) { 
                    height: calc(100vh - 11.8rem);
                    padding-bottom: 11.8rem !important;
                }
            }
            > div {
                max-height: 100vh;
                margin: 0 0 0 auto;
                max-width: 35.625rem;
                border: 1px solid rgba(7,15,44,0.08);
                border-radius: 1px;
                background-color: ${themeColors.colorWhite};
                @media (max-width: 767px) {
                    max-width: 100%;
                    margin-right: 0;
                    margin-left: 0;
                }

                > div:last-child {
                    padding: 0;
                    > form {
                        > div {
                            padding: 1.875rem;
                        }

                        > div:last-child {
                            border-radius: 1px;
                            background: ${themeColors.colorWhite};
                            box-shadow: 0 -0.125rem 0.375rem 0 rgba(0,0,0,0.31);
                            padding-left: 0;
                            padding-right: 0;

                            @media screen and (max-width: 767px) {
                                box-shadow: none;
                            }
                        }
                        @media screen and (max-width: 326px) {
                            > div {
                                padding: 1.875rem 1.875rem 2.2rem;                           
                            }
                            > div:last-child {
                                padding-top: 7.5rem;
                                padding-bottom: 3.875rem;
                            } 
                        }
                        @media screen and (min-width: 360px) and (max-width: 369px) {                            
                            > div:last-child {
                                padding-top: 5rem;
                            } 
                        }
                        @media screen and (min-width: 370px) and (max-width: 379px) {                          
                            > div:last-child {
                                padding-top: 2.8rem;
                            }
                        }
                        @media screen and (min-width: 380px) and (max-width: 414px) {                        
                            > div:last-child {
                                padding-top: 3rem;
                            }
                        }
                    }
                }
                #modalTitle{
                    border-bottom: none;
                    padding-bottom: 0px;
                    h4 {
                        color: ${themeColors.colorPrimary};
                        font-family: Roboto;
                        font-size: 1.125rem;
                        font-weight: ${themeFontWeights.fontWeightMedium};
                        letter-spacing: 0px;
                        line-height: 1.9375rem;
                        padding-top: 4.0625rem;
                        position: relative;
                        &:after {
                            height: 0.1875rem;
                            width: 2.75rem;
                            background: ${themeColors.colorRed};
                            content: "";
                            display: inline-block;
                            position: absolute;
                            bottom: -0.1875rem;
                            left: 1px;
                        }
                    }
                    button[aria-labelledby="close-modal"] {
                        display: none;
                    }
                }
            }
        `,
    },
    addressInfoDisplayGridItem: { 
        width: 12,
        css: css`
            color: ${themeColors.colorSquidInk};
            font-family: 'Lato';
            p {
                font-size: 1rem;
            }

             span[data-test-selector="addressInfoDisplay_firstName"],
             span[data-test-selector="addressInfoDisplay_lastName"] {
                font-weight: ${themeFontWeights.fontWeightForBold};
                font-size: 1rem;
                color: ${themeColors.colorPrimary};
            }
        `,
    },
    useBillingAddressButtonGridItem: { 
        width: 10,
        css: css`
            display: flex;
        `,
    },
    useBillingAddress: {
        button: {
            css: css`
                color: ${themeColors.colorBattleshipGray};
                font-family: Lato;
                font-size: 0.9375rem;
                letter-spacing: 0.17px;
                line-height: 1.125rem;
                background: transparent;
                border: none;
                margin-top: 0;
                height: auto;
                padding: 0;
                text-transform: none;

                &:hover {
                    background: transparent;
                    border: none;
                    color: ${themeColors.colorBattleshipGray};
                }

                > span {                    
                    font-weight: ${themeFontWeights.fontWeightNormal};
                    text-decoration: underline;
                }
            `,
        },
    },
};

const styles = currentShippingAddressStyles;

const CurrentShippingAddress: React.FunctionComponent<Props> = (props: Props) => {
    const { currentShipTo, currentBillTo, currentShipTosDataView, loadCurrentShipTos } = props;
    const [deleteModalIsOpen, setDeleteModalIsOpen] = React.useState(false);
  
    useEffect(() => {
        // we reset all dataviews when adding a new address, so we have to load these if they go away
        if (!currentShipTosDataView.value && !currentShipTosDataView.isLoading) {
            loadCurrentShipTos();
        }
    });

    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    if (!currentShipTo || !currentBillTo || !currentShipTosDataView.value) {
        return null;
    }
    const currentShipToData=  { ...currentShipTo };
    currentShipToData.isDefault=true;

    const billToAsShipTo = currentShipTosDataView.value.find(o => o.id === currentBillTo.id);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        setDeleteModalIsOpen(false);
    };
    const closeDeleteModelhandler=()=>{
        setDeleteModalIsOpen(false);
        window.location.reload();
    };
    const editClickHandler = () => {
        setModalIsOpen(true);
    };
    const useBillingAddressHandler = () => {
        if (!billToAsShipTo) {
            return;
        }
        props.setCurrentShipTo({
            shipToId: billToAsShipTo.id,
        });
    };
    const formCancelHandler = (e: any) => {
        e.preventDefault();
        modalCloseHandler();
    };
    const formSubmitHandler = (_: React.FormEvent<HTMLFormElement>, address: ShipToModel) => {
        if (!currentBillTo || !currentShipToData) {
            return;
        }

        props.updateShipTo({
            billToId: currentBillTo.id,
            shipTo: {
                ...currentShipToData,
                ...address,
            },
        });
        modalCloseHandler();
    };

    const deleteHandler = () => { setDeleteModalIsOpen(true); }; 
    const deleteSubmitHandler = () => { 
        if (!currentBillTo || !currentShipToData) {
            return;
        }
        props.updateShipTo({ 
            billToId: currentBillTo.id, 
            shipTo: { ...currentShipToData, }, 
            additionalQueryStringParameters: { canDelete: true }, 
        }); 
        closeDeleteModelhandler(); 
    };

    const { countries, shipToAddressFields } = props;
    return (
        <GridContainer {...styles.gridContainer} data-test-seletor="test22">
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.headingText}>
                    {translate("Shipping Information")}                   
                </Typography>
            </GridItem>
            
            <GridItem
                {...styles.addressInfoDisplayGridItem}
                data-test-selector="addressInfoDisplay_CurrentShippingAddress"
            >
                <AddressInfoDisplay
                    firstName={currentShipToData.firstName}
                    lastName={currentShipToData.lastName}
                    companyName={currentShipToData.companyName}
                    attention={currentShipToData.attention}
                    address1={currentShipToData.address1}
                    address2={currentShipToData.address2}
                    address3={currentShipToData.address3}
                    address4={currentShipToData.address4}
                    city={currentShipToData.city}
                    state={currentShipToData.state ? currentShipToData.state.abbreviation : undefined}
                    postalCode={currentShipToData.postalCode}
                    country={currentShipToData.country ? currentShipToData.country.abbreviation : undefined}
                    phone={currentShipToData.phone}
                    fax={currentShipToData.fax}
                    email={currentShipToData.email}
                />
            </GridItem>
            <StyledWrapper {...styles.currentAddressAction}>
        
                <GridItem {...styles.useBillingAddressButtonGridItem}>
                {currentShipToData.id !== currentBillTo.id && ( 
                    <UseBillingAddressButton onClick={useBillingAddressHandler} />
                )} 
                </GridItem>
               

                <GridItem {...styles.editLinkGridItem}>
                    {countries && (
                        <>
                        {currentShipToData.id !== currentBillTo.id && currentShipToData.properties?.isErpNumberNotAvailable === "true" && (
                            <Link
                                {...styles.deleteLink}
                                onClick={deleteHandler}
                                data-test-selector="current_address_delete"
                            >
                                <Icon src="Trash2" />
                                <VisuallyHidden>{translate("Delete")}</VisuallyHidden>
                            </Link>
                          )} 
                            <Link
                                {...styles.editLink}
                                onClick={editClickHandler}
                                data-test-selector="shipTo_Edit_Address"
                            >
                                <Icon src={EditIcon} />
                                <VisuallyHidden>{translate("Edit")}</VisuallyHidden>
                            </Link>
                        </>
                    )}
                    {countries && shipToAddressFields && (
                        <>
                            <Modal
                                headline={translate("Edit shipping information address")}
                                {...styles.addressFormModal}
                                isOpen={modalIsOpen}
                                handleClose={modalCloseHandler}
                                {...styles.addressFormModalCustom}
                            >
                                <Typography as="div" onClick={modalCloseHandler} {...styles.closeContainer}>
                                    <span className="close-label">Close</span>
                                    <Icon className="icon-close" src="XCircle" />
                                </Typography>
                                <CustomerAddressForm
                                    address={currentShipToData}
                                    countries={countries}
                                    addressFieldDisplayCollection={shipToAddressFields}
                                    onCancel={formCancelHandler}
                                    onSubmit={formSubmitHandler}
                                />
                            </Modal>
                       
                        </>
                    )}
                </GridItem>

            </StyledWrapper>

            <TwoButtonModal headlineText={translate("Delete Addresses")}
             // {...styles.deleteListModal}                    
             modalIsOpen={deleteModalIsOpen} 
             messageText={translate("Are you sure you want to delete this address")}
             cancelButtonText={translate("Cancel")}
             submitButtonText={translate("Delete")} 
             onCancel={modalCloseHandler} 
             onSubmit={deleteSubmitHandler} 
             submitTestSelector="submitDeleteList">

             </TwoButtonModal>
        </GridContainer>
    );
};

interface UseBillingAddressButtonProps {
    onClick: () => void;
}

const UseBillingAddressButton: React.FunctionComponent<UseBillingAddressButtonProps> = (
    props: UseBillingAddressButtonProps,
) => {
    const componentStyles: UseBillingAddressStyles = styles.useBillingAddress || {};
    return (
        <Button {...componentStyles.button} onClick={props.onClick} data-test-selector="useAsBillingAddressText">
            {translate("Use billing address ")}
        </Button>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CurrentShippingAddress),
    definition: {
        group: "Addresses",
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
